import { render, staticRenderFns } from "./UpdatePriorityModal.vue?vue&type=template&id=3fbb29fe&scoped=true"
import script from "./UpdatePriorityModal.vue?vue&type=script&lang=js"
export * from "./UpdatePriorityModal.vue?vue&type=script&lang=js"
import style0 from "./UpdatePriorityModal.vue?vue&type=style&index=0&id=3fbb29fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb29fe",
  null
  
)

export default component.exports